import React from 'react';
import PropTypes from 'prop-types';

import { useRequestData } from 'wsm-common-data';

const FacetButtonLink = ({ onClick, buttonText }) => {
	const { deviceType } = useRequestData();
	const isDesktop = deviceType === 'DESKTOP';

	return (
		<button
			type="button"
			className={`text-link text-decoration-underline text-primary text-left ${
				isDesktop ? '' : 'mt-3'
			}`}
			onClick={onClick}
		>
			<span className="ddc-font-size-xsmall">{buttonText}</span>
		</button>
	);
};

FacetButtonLink.propTypes = {
	onClick: PropTypes.func.isRequired,
	buttonText: PropTypes.string.isRequired
};

export default FacetButtonLink;
